module.exports = {
      id: "video-outline-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#video-outline",
      toString: function () {
        return this.url;
      }
    }